import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="text"
export default class extends Controller {
  static targets = ["textToCopy", "copyButton"];

  declare textToCopyTarget: HTMLElement;
  declare hasTextToCopyTarget: boolean;
  declare copyButtonTarget: HTMLElement;
  declare hasCopyButtonTarget: boolean;

  connect() {}

  async copyText() {
    if (!this.hasTextToCopyTarget || !window.isSecureContext) return;
    await navigator.clipboard.writeText(this.textToCopyTarget.innerText);
    if (!this.hasCopyButtonTarget) return;
    this.copyButtonTarget.innerText = "Copié !";
  }
}
